<script lang="ts">
	import type { InventoryType, SearchField } from 'utility/search-fields'
	import type { SvelteSet } from 'svelte/reactivity'
	import type { ComponentProps } from 'svelte'

	import InventoryTypeAutocomplete from './InventoryTypeAutocomplete.svelte'
	import EditModeControls from './EditModeControls.svelte'
	import Pin from './Pin.svelte'

	interface Props
		extends Omit<ComponentProps<typeof InventoryTypeAutocomplete>, 'hint' | 'inventoryType' | 'disabled'> {
		searchField: SearchField
		inEditMode: boolean
		pinnedSearchFields: SvelteSet<SearchField['key']> //Required
		selectedSearchFieldsKeys: SvelteSet<SearchField['key']> //Required
		inventoryType?: InventoryType | null
		initialValue?: number // For backward compatibility
		disabled?: boolean
	}

	let {
		searchField,
		inEditMode,
		pinnedSearchFields = $bindable(),
		selectedSearchFieldsKeys = $bindable(),
		inventoryType = $bindable(null),
		initialValue,
		disabled = false,
		...rest
	}: Props = $props()
</script>

<EditModeControls
	{searchField}
	{inEditMode}
	{pinnedSearchFields}
	{selectedSearchFieldsKeys}
>
	<InventoryTypeAutocomplete
		{...rest}
		{initialValue}
		bind:inventoryType
		disabled={inEditMode || disabled}
	>
		{#snippet hint()}
			<Pin isPinned={pinnedSearchFields.has(searchField.key)} />
		{/snippet}
	</InventoryTypeAutocomplete>
</EditModeControls>
